import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import classes from './pagination.module.scss';

export const CustomPagination = ({ className = '', slidesAmount, currentIndex, onClick }) => {
    return (
        <div className={clsx(classes.pagination, className)}>
            {[...Array(slidesAmount)].map((key, index) => {
                return (
                    <button
                        key={index}
                        className={clsx(classes.dot, currentIndex === index && classes.active)}
                        onClick={() => {
                            onClick(index);
                        }}
                    />
                );
            })}
        </div>
    );
};
